module.exports = __webpack_public_path__ + "img/L15.848cb5fa.jpg";